// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1vgKR","requiredAsterisk":"Info_requiredAsterisk__egfod"};